import type { EventLogEntry } from "../types.js";

export function initNavigationSession() {
  const sessionStartMs =
    typeof performance !== 'undefined' && typeof performance.timeOrigin === 'number'
      ? performance.timeOrigin
      : Date.now();

  return {
    sessionStartMs,
    loadEvents: (): EventLogEntry[] => [],
    save: (_buffer: EventLogEntry[]): void => {},
    destroy: (): void => {},
  };
}
